export default __webpack_public_path__ + "static/media/card-profile1-square.733ed295.jpg";